
import { defineComponent, SetupContext, ref } from "vue";
import NativeClient from "@/client/native-client";
import { RecipeFoodItemInfo, FoodTipData, ShelfLifeTips } from "@/types/pantry";
import PantryFoodTipTitle from "./PantryFoodTipTitle.vue";
import PantryFoodTipData from "./PantryFoodTipData.vue";
export default defineComponent({
  name: "PantryFoodInfoView",
  components: {
    PantryFoodTipTitle,
    PantryFoodTipData
  },
  props: {
    info: {
      type: RecipeFoodItemInfo,
      default: null
    }
  },
  setup(props, context: SetupContext) {
    const selectId = ref(0);
    const getTipList = () => {
      const list = Array<FoodTipData>();
      if (props.info && props.info.item) {
        let i = 0;
        if (props.info.item.description && props.info.item.description != "") {
          const item = new FoodTipData(i++, "概要", new ShelfLifeTips(null, props.info.item.description));
          list.push(item);
        }
        if (props.info.item.tips) {
          for (const tip of props.info.item.tips) {
            if (tip && tip.description != "") {
              const title = tip.shelfTypeName;
              const item = new FoodTipData(i, title, new ShelfLifeTips(tip.image, tip.description));
              list.push(item);
              i++;
            }
          }
        }
      }
      return list;
    };
    const onSelectTip = (id: number) => {
      if (id != -1 && selectId.value != id) {
        selectId.value = id;
      }
    };
    const clickQuestion = () => {
      context.emit("show-guide");
    };

    return {
      selectId,
      getTipList,
      onSelectTip,
      clickQuestion
    };
  }
});
